// The cloud sandboxes in Me: what their events read again, and what is kept
// across reloads (the person's sandboxes, so the device list draws "trameria"
// at once instead of the stored name first).
//
// - `cloud.status { profile }` (to the owner, when anything of SandboxDTO
//   changes): the person's sandboxes and devices.
// - `preview.list {}` (to everyone who may see previews): the previews.
import { defineScreenPart } from "@trameria/ui-core";
import { meCloudKey, previewsKey, refreshSandboxes } from "./queries";

export const sandboxesPart = defineScreenPart({
  id: "sandboxes",
  realtime: {
    "cloud.status": (_payload, { qc }) => void refreshSandboxes(qc),
    "preview.list": (_payload, { qc }) =>
      void qc.invalidateQueries({ queryKey: previewsKey }),
  },
  persist: (key) => key[0] === meCloudKey[0] && key[1] === meCloudKey[1],
});
